module.exports = __webpack_public_path__ + "img/mobile_edit_menu_icon.29ef0fe3.svg";